import { render, staticRenderFns } from "./HeaderShell.vue?vue&type=template&id=e2534704&"
import script from "./HeaderShell.vue?vue&type=script&lang=js&"
export * from "./HeaderShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports